import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, unref as _unref, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "font-weight-regular opacity-90"
}

import {Feedback, isStartable, Order, Task} from "@/types/Order";
import FeedbackForm from "@/components/forms/FeedbackForm.vue";
import TimeLine from "@/components/misc/TimeLine.vue";
import {computed, shallowRef} from "vue";
import TaskInformationDialog from "@/components/dialogs/TaskInformationDialog.vue";
import {useGlobalSetting} from "@/lib/utils";
import {addFeedback} from "@/api";
import {updateTaskState} from "@/api/tasks";

interface EditTab {
  icon: string;
  text: string;
  value: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'TaskDialog',
  props: /*@__PURE__*/_mergeModels({
  id: {
    type: Number,
    required: true
  },
  onClose: {
    type: Function,
    required: true
  },
  currentTab: {
    type: String,
    required: false,
    default: 'tab-1'
  }
}, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props) {

const record = _useModel<Order>(__props, "modelValue");

//console.log("record", record.value);

const props = __props;

const task = computed<Task>(() => record.value?.tasks.find(aufg => aufg.id == props.id));

const canSave = computed(() => {
  const newFeedbacks = task.value?.feedbacks?.filter(fb => fb._isNew) ?? []
  return newFeedbacks.every(fb => fb.duration && fb.duration !== '')
})


const currentEditTab = shallowRef<string>(props.currentTab);

const editTabs: EditTab[] = [
  {
    icon: 'mdi mdi-information-slab-box',
    text: 'Information',
    value: 'tab-1'
  },
  {
    icon: 'mdi mdi-reply',
    text: 'Rückmeldung',
    value: 'tab-2'
  },
  {
    icon: 'mdi mdi-book-clock-outline',
    text: 'Zeitplan',
    value: 'tab-3'
  },
]

function cancel() {
  useGlobalSetting().hasChanged = false;
  props.onClose?.();
}

async function submit() {
  const newFeedbacks = task.value.feedbacks.filter(fb => fb._isNew).map(({_isNew, id, task_id, ...rest}) => rest) as Feedback[]

  await updateTaskState(task.value);

  await addFeedback(task.value.uuid, newFeedbacks)
  useGlobalSetting().hasChanged = false;
  props.onClose?.();
}


return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs_window_item = _resolveComponent("v-tabs-window-item")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    class: "d-flex flex-column",
    height: "100vh"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_sheet, { class: "flex-grow-1 overflow-auto" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_toolbar, {
            color: "primary",
            density: "compact",
            class: "px-4"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, {
                icon: "mdi-clipboard-list",
                class: "mr-2"
              }),
              _createVNode(_component_v_toolbar_title, { class: "text-subtitle-1 font-weight-medium" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(record.value?.id) + "#" + _toDisplayString(task.value.id) + " ", 1),
                  (record.value?.title)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_1, " - " + _toDisplayString(record.value.title), 1))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (!_unref(isStartable)(record.value, task.value.id))
            ? (_openBlock(), _createBlock(_component_v_sheet, {
                key: 0,
                class: "flex-grow-1 d-flex align-center justify-center"
              }, {
                default: _withCtx(() => _cache[6] || (_cache[6] = [
                  _createElementVNode("span", { class: "ml-2 color_error pr-2" }, " Vorherige Aufgabe ist nicht beendet!", -1)
                ])),
                _: 1,
                __: [6]
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_v_tabs, {
            modelValue: currentEditTab.value,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((currentEditTab).value = $event)),
            items: editTabs,
            "align-tabs": "center",
            color: "primary",
            height: "60",
            "slider-color": "primary"
          }, {
            tab: _withCtx(({ item }) => [
              _createVNode(_component_v_tab, {
                "prepend-icon": item.icon,
                text: item.text,
                value: item.value,
                class: "text-none"
              }, null, 8, ["prepend-icon", "text", "value"])
            ]),
            item: _withCtx(({ item }) => [
              _createVNode(_component_v_tabs_window_item, {
                value: item.value,
                class: "pa-4"
              }, {
                default: _withCtx(() => [
                  (item.value === 'tab-1')
                    ? (_openBlock(), _createBlock(TaskInformationDialog, {
                        key: 0,
                        modelValue: task.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((task).value = $event)),
                        readonly: _unref(useGlobalSetting)().globalReadonly
                      }, null, 8, ["modelValue", "readonly"]))
                    : _createCommentVNode("", true),
                  (item.value === 'tab-2')
                    ? (_openBlock(), _createBlock(FeedbackForm, {
                        key: 1,
                        modelValue: task.value,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((task).value = $event))
                      }, null, 8, ["modelValue"]))
                    : _createCommentVNode("", true),
                  (item.value === 'tab-3')
                    ? (_openBlock(), _createBlock(TimeLine, {
                        key: 2,
                        modelValue: record.value,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((record).value = $event)),
                        aufgabe: task.value,
                        "onUpdate:aufgabe": _cache[3] || (_cache[3] = ($event: any) => ((task).value = $event))
                      }, null, 8, ["modelValue", "aufgabe"]))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1032, ["value"])
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_v_divider),
      _createVNode(_component_v_card_actions, { class: "bg-surface-light" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_btn, {
            variant: "plain",
            onClick: _cache[5] || (_cache[5] = ($event: any) => {cancel(); currentEditTab.value = 'tab-1'; _unref(useGlobalSetting)().hasChanged = false;})
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, {
                color: "red",
                icon: "mdi-cancel",
                start: ""
              }),
              _cache[7] || (_cache[7] = _createTextVNode(" Abbrechen "))
            ]),
            _: 1,
            __: [7]
          }),
          _createVNode(_component_v_spacer),
          _createVNode(_component_v_btn, {
            disabled: !_unref(useGlobalSetting)().hasChanged || !canSave.value,
            text: "Save",
            onClick: submit
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, {
                color: "green",
                icon: "mdi-checkbox-marked-circle",
                start: ""
              }),
              _cache[8] || (_cache[8] = _createTextVNode(" Speichern "))
            ]),
            _: 1,
            __: [8]
          }, 8, ["disabled"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})